export function CustomerRecordsPage({ render }) {
  return render();
}
